import { mapValues, set, sortBy, orderBy } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { fetchInventoryAuditLogsSearchOptions } from '../../sagas/routines';
import { clearInventoryAuditLogsSearchOptions } from '../../actions';

const initialState = {
  users: [],
  items: [],
  locations: [],
  zones: [],
  tags: [],
  fetching: false,
  fetched: false,
  fetchingError: null
};

export const fetchAuditLogsSearchOptionsHandler = routine => ({
  [routine.TRIGGER]: set('fetching', true),
  [routine.SUCCESS]: (state, { payload: { response } }) => {
    const { zones, ...options } = response;
    return {
      ...state,
      ...mapValues(sortBy(({ label }) => label.toLowerCase()), options),
      zones: orderBy(
        [
          ({ location }) => location.toLowerCase(),
          ({ label }) => label.toLowerCase()
        ],
        ['asc'],
        zones
      )
    };
  },
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const clearInventoryAuditLogsSearchOptionsHandler = action => ({
  [action.toString()]: set('searchOptions', {})
});

export default createReducer(initialState, {
  ...fetchAuditLogsSearchOptionsHandler(fetchInventoryAuditLogsSearchOptions),
  ...clearInventoryAuditLogsSearchOptionsHandler(
    clearInventoryAuditLogsSearchOptions
  )
});
